import React, { useState } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { LuSend, LuInfo } from "react-icons/lu";
import { sendInvitation } from '../../redux/reducers/invitationSlice';

const SendInvitationModal = ({ show, onHide }) => {
  const dispatch = useDispatch();
  const { sending } = useSelector((state) => state.invitation);
  // const businessId = useSelector((state) => state.auth.user?.primaryBusinessId);
  const businessId = localStorage.getItem('activeBusinessId');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');

  const handleSubmit = (e) => {
    console.log('e', email, businessId);
    e.preventDefault();
    if (!email || !businessId) return;

    dispatch(sendInvitation({ email, name, businessId })).then((res) => {
      if (!res.error) {
        onHide();
        setEmail('');
        setName('');
      }
    });
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold" style={{ fontSize: '18px' }}>Send Portal Invitation</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-3">
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label className="small fw-semibold">Customer Email*</Form.Label>
            <Form.Control
              type="email"
              placeholder="e.g. customer@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{ borderRadius: '8px' }}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="small fw-semibold">Customer Name*</Form.Label>
            <Form.Control
              type="text"
              placeholder="e.g. John Doe"
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={{ borderRadius: '8px' }}
            />
          </Form.Group>

          <div className="rounded-3 p-3 mb-4 d-flex gap-2" style={{ background: '#f8fafc', border: '1.5px solid #e2e8f0' }}>
            <LuInfo size={16} className="text-primary flex-shrink-0 mt-1" />
            <div className="small text-muted">
              An invitation will be sent with a link to complete their profile. Link expires in 7 days.
            </div>
          </div>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="light" onClick={onHide} className="rounded-3 px-4 fw-semibold">
              Cancel
            </Button>
            <Button 
              type="submit" 
              className="rounded-3 px-4 fw-semibold d-flex align-items-center gap-2"
              style={{ background: '#28B0C4', border: 'none', color: 'white' }}
              disabled={sending || !email}
            >
              {sending ? <Spinner size="sm" /> : <LuSend size={16} />}
              Send Invitation
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default SendInvitationModal;
